import styled from '@emotion/styled'

/**
 * A altura reservada muda com a largura da tela porque a propria vitrine muda:
 * medida em 10 larguras, ela salta entre 600px e 768px — o breakpoint md do
 * Chakra. Reservar um unico valor obrigaria a escolher o maior, sobrando ~230px
 * no celular, e o bloco encolheria ao montar.
 *
 * Emotion em vez de style inline porque style inline nao aceita media query.
 */
export const ReservedBlock = styled.div<{
  heightBelowMd?: string
  heightFromMd?: string
}>`
  ${({ heightBelowMd }) => heightBelowMd && `min-height: ${heightBelowMd};`}

  @media (min-width: 48em) {
    ${({ heightFromMd }) => heightFromMd && `min-height: ${heightFromMd};`}
  }
`
